import WRAP from 'WRAP-JS'
import { MAP_ID_TILEMAP } from "../../../store/MapContentsState";
class TileMap {
  static NAME = MAP_ID_TILEMAP;
  dh;
  layerConfig;
  layer;
  color;
  whitePalette = [];
  blackPalette = [];

  constructor(color) {
    this.color = color;
    this.layer = new WRAP.Geo.Layer('TileMap');
    this.layer.setVisible(false);
  }

  initialize() {
    this.initData();
    this.initLayer()
  }

  initData() {
    this.dh = new WRAP.Data({
      "Controller": {
        "Name": "EXPO_Tile"
      },
      "Source": {
        "data": {
          "Type": "TMS",
          "Name": "MAP_ReliefAntialias_MER",
          "_url": "%expo_map_url%/png_tile/NGA_VMAP_MERCTR/%z%_%y%_%x%.png",
          "url": "%expo_map_url%/png_tile/NGA_VMAP_MERCTR/%z%_%y%_%x%.png",
          "cache": true,
          "download_max": 32,
          "Grid": {
            "MinZoom": 0,
            "MaxZoom": 14,
            "Complement" : true,
            "YCoordinate": -1,
            "BoundingBox": {
              "West": -180,
              "South": -90,
              "East": 180,
              "North": 90
            }
          }
        }
      }
    });
  }

  initLayer() {
    this.layerConfig = {
      "Name": "TileMap",
      "Renderer": "Image",
      "Attributes": {
        "style": {
          "default": {
            "type": "grayscale_palette",
            "min_filter": "NEAREST",
          }
        }
      }
    };


    this.whitePalette.push([255, 255, 255, 255]); //sea
    this.blackPalette.push([0, 0, 0, 255]);//sea
    for (let i = 0; i < 254; i += 1) {
      this.whitePalette.push([0, 0, 0, 0]);
      this.blackPalette.push([0, 0, 0, 0]);
    }
    this.whitePalette.push([240, 239, 232, 255]);//land
    this.blackPalette.push([34, 34, 34, 255]);//land

    this.layerConfig.Attributes.style.default.palette = this.color === 'white'? this.whitePalette : this.blackPalette;
    this.layer.configure(this.dh, this.layerConfig);
    this.layer.set({});
  }

  async drawLayer(visible) {
    if (!this.dh) {
      this.initialize();
    }
    this.setVisible(visible);
  }
  getLayer() {
    return this.layer;
  }

  setVisible(visible) {
    if (visible) {
      this.layer.show();
    } else {
      this.layer.hide();
    }
  }

  applyMapColor(color) {
    this.color = color;
    this.layerConfig.Attributes.style.default.palette = this.color === 'white'? this.whitePalette : this.blackPalette;
    this.layer.invalidate();
  }
}

export default TileMap;